// extracted by mini-css-extract-plugin
module.exports = {"container":"e_CG","icon":"e_DG"};